import React from 'react';

import { observer } from 'mobx-react';
import { Button } from '@infoods/lifebase-ui';

import classes from './DashboardBanner.module.scss';
import { getUserName } from '../../../../shared/utils/userInfoUtils';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import dashboardBannerImage from '../../../../shared/assets/image/banners/img-banner-dashboard.png';
import { openModal } from '../../../../shared/utils/reactUtils/openModal/openModal';
import { YoutubeVideoModal } from '../../../../shared/components/modals';
import { dashboardLearnMoreVideoLink } from '../../../constants/externalLinks';
import { FLAGS, useFlag } from '../../../../shared/clients/unleash';

const DashboardBanner = observer(() => {
  const isShowLearnMoreButton = useFlag(FLAGS.SHOW_LEARN_MORE_BUTTON);
  const { loggedInUser } = loggedInUserDataStore;

  const userName = getUserName(loggedInUser);

  const handleLearnMore = () => {
    openModal((closeModal) => (
      <YoutubeVideoModal
        open
        onClose={closeModal}
        videoSrc={dashboardLearnMoreVideoLink}
      />
    ));
  };

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <p className={classes.greeting}>Hello, {userName}</p>
        <p className={classes.title}>
          <span className={classes.headline}>Real-time analytics </span> for scanning
          activity, customer behavior, and nutrition insights
        </p>
        {isShowLearnMoreButton && (
          <Button
            variant="contained"
            size="small"
            className={classes.learnMoreButton}
            onClick={handleLearnMore}
          >
            Learn More
          </Button>
        )}
      </div>
      <div className={classes.imageContainer}>
        <img src={dashboardBannerImage} alt="dashboard-banner-image" />
      </div>
    </div>
  );
});

export { DashboardBanner };
